export default __webpack_public_path__ + "static/media/OwnerAssign.b7484801.svg";